const MEALPLAN_INFO = (state, data) => {
  state.MealPlanInfo = data
}

const MEAL_PLAN_RECEIPT_INFO = (state, listMealPlanInfo) => {
  state.listMealPlanInfo = listMealPlanInfo
}

const MEAL_PLAN_RECEIPT_INFO_BY_VOUCHER_CODE = (state, mealPlanInfo) => {
  state.MealPlanPriceTotalPax = mealPlanInfo
}

const RESET_MEALPLAN_INFO = (state) => {
  state.MealPlanInfo = {}
}

export default {
  MEALPLAN_INFO,
  MEAL_PLAN_RECEIPT_INFO,
  MEAL_PLAN_RECEIPT_INFO_BY_VOUCHER_CODE,
  RESET_MEALPLAN_INFO
}
